@if (processedItem(); as item) {
  <div class="target-resource-list-item l_flexbar guts-p-v-1">
    <div>
      @switch (item.referenceType) {
        @case ('User') {
          <div>
            <dgx-profile-pic [profile]="item" size="small" class="guts-m-h-1" />
          </div>
        }
        @case ('Provider') {
          <div>
            <img
              class="provider__flex-search-image guts-m-h-1"
              [alt]="item.title"
              [src]="item.providerImageUrl"
            />
          </div>
        }
        @case ('Tag') {
          <div>
            <div
              class="icon-spot bg-color-ebony-a08-hue center-item guts-m-h-1"
            >
              <da-icon
                [icon]="resourceTypeIcon(item.referenceType)"
                type="solid-small"
                class="tw-reset tw-inline-block tw-align-middle tw-text-neutral-600"
              />
            </div>
          </div>
        }
        @case ('Group') {
          <div>
            <div
              class="icon-spot bg-color-ebony-a08-hue center-item guts-m-h-1"
            >
              <da-icon
                icon="users"
                type="solid-small"
                class="tw-reset tw-inline-block tw-align-middle tw-text-neutral-600"
              />
            </div>
          </div>
        }
        @case ('Target') {
          <div>
            <div
              class="icon-spot bg-color-ebony-a08-hue center-item guts-m-h-1"
            >
              <da-icon
                icon="newspaper"
                type="solid-small"
                class="tw-reset tw-inline-block tw-align-middle tw-text-neutral-600"
              />
            </div>
          </div>
        }
        @case ('Pathway') {
          <!-- Empty case for Pathway -->
        }
        @default {
          <div class="guts-m-h-1">
            <dgx-image-layout
              format="list"
              [imageSrc]="item.image"
              [videoUrl]="item.referenceType === 'Video' ? item.url : ''"
              [providerImage]="
                $safeNavigationMigration(item.providerImageInfo?.svg)
              "
            />
          </div>
        }
      }
    </div>

    <div>
      <h3 class="par par--small font-bold">
        {{ item.title }}
        @if (item.endorsedSrc) {
          <img
            class="tag-endorsed-img v-bottom"
            [src]="item.endorsedSrc"
            [alt]="i18n().Core_Endorsed"
          />
        }
      </h3>
      @if (item.details) {
        <p
          class="par par--small par--light guts-p-full-0"
          [textContent]="item.details"
        ></p>
      }
      <p class="par par--small par--light guts-m-r-half">
        <span>{{ item.displayType }}</span>
      </p>
    </div>
  </div>
}
